import React from 'react';
import { ContentContainerType } from 'types/enums';
import { breakpoints } from 'app/constants';
import { Container, ContainerProps } from '@chakra-ui/react';

interface ContentContainerProps extends ContainerProps {
  type?: ContentContainerType;
  isViewContent?: boolean;
}

const containerPadding = 16;
const maxWidthMap = {
  [ContentContainerType.FORM]: 1236,
  [ContentContainerType.LIST]: 1536 + containerPadding * 2,
  [ContentContainerType.NARROW_LIST]: 1536,
  [ContentContainerType.APP]: breakpoints.mobileScreen,
};

export const CONTENT_CONTAINER_CLASSNAME = 'content-container';

export const ContentContainer: React.FC<ContentContainerProps> = ({
  children,
  type = ContentContainerType.LIST,
  isViewContent,
  px,
  ...props
}) => (
  <Container
    className={CONTENT_CONTAINER_CLASSNAME}
    position="relative"
    display="flex"
    flexDirection="column"
    maxHeight="100%"
    justifyContent={props.centerContent ? 'center' : 'start'}
    px={px || containerPadding / 4}
    maxWidth={maxWidthMap[type]}
    pt={isViewContent ? 6 : undefined}
    flex={1}
    pb={props.pb || (isViewContent ? '96px' : undefined)}
    {...props}
  >
    {children}
  </Container>
);
